import React, { Component } from 'react';
import { decorate, observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";

import './style.scss';
import categoryCode from './categoryCode';

import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
    Form,
    FormGroup,
    FormInput,
    FormSelect,
    Button,
    Card,
    CardBody,
    CardHeader,
    Collapse,
    Row,
    Col,
    Container,
    Badge,
    InputGroup,
    InputGroupAddon,
    FormRadio,
    FormCheckbox, FormTextarea
} from "shards-react";
import {Link} from "react-router-dom";
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import imgKakaoTemp from "../../../images/img/img_kakaoTemp.png";


// https://smartsms.aligo.in/alimapi.html
@inject(({ common }) => ({ getDoc: common.getDoc, updateDoc: common.updateDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ booster }) => ({ addKakaoProfile: booster.addKakaoProfile, getBoosterSetting: booster.getBoosterSetting, setBoosterSetting: booster.setBoosterSetting, setKakaoTemp:booster.setKakaoTemp }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))

@observer
class KakaoMsgSetting extends Component {

    // basic
    @observable store = {};
    @observable teamUser = {};
    @observable permissions = {};
    @observable isLogin = false;
    @observable isLoading = false;

    // settings
    @observable authStep = 1;
    @observable regedPlusId = false;
    @observable category = ["", "" ,""];

    @observable firstSendOptions = [
        { value: 0, label: "도착 당일 발송" },
        { value: 1, label: "1일 후 발송" },
        { value: 2, label: "2일 후 발송" },
        { value: 3, label: "3일 후 발송" },
        { value: 5, label: "5일 후 발송" },
    ];
    @observable resendTypeOptions = [
        { value: "total", label: "통합 (작성가능 리스트 1회 발송)" },
        { value: "product", label: "상품(주문상품 마다 알림톡 발송)" }
    ];

    @observable sendIntervalOptions = [
        { value: 1, label: "1일 마다" },
        { value: 2, label: "2일 마다" },
        { value: 3, label: "3일 마다" },
        { value: 4, label: "4일 마다" },
        { value: 5, label: "5일 마다" },
    ];
    @observable sendCountOptions = [
        { value: 1, label: "1회" },
        { value: 2, label: "2회" },
        { value: 3, label: "3회" },
        { value: 4, label: "4회" },
        { value: 5, label: "5회" },
    ];

    @observable categoryOptions = {
        firstCate : categoryCode.data.firstBusinessType
    };

    @observable boosterSetting = {
        isKakaoPlusidAuth: false,
        kakaoPlusid: "",
        phonenumber: "",
        authnum: "",
        categorycode: "",
        isUse: false,
        firstSend: 2,
        isResend: true,
        resendType: "total",
        sendInterval : 2,
        sendCount : 3,
        sendStartTime: 6,
        sendEndTime: 18,
    };

    constructor(props) {
        super(props);
        this.init();
    }

    @action
    init = async () => {
        if (this.props.isLogin) {
            // basic
            this.isLogin = this.props.isLogin;
            this.teamUser = this.props.me;
            this.store = this.props.me.store ? this.props.me.store : {};
            this.permissions = this.props.me.permissions;

            this.boosterSetting.store_id = this.teamUser.selStore_id;
            this.boosterSetting.shopNo = this.teamUser.selShopNo || 1;
            // this.boosterSetting.kakaoPlusid = this.store.kakaoPlusid && this.store.kakaoSenderkey ? this.store.kakaoPlusid : "";

            // Load settings
            this.getSettings();
        }
    };

    @action
    getSettings = async () => {
        let _this = this;
        this.isLoading = true;
        const params = {
            store_id: this.teamUser.selStore_id,
            shopNo: this.teamUser.selShopNo || 1
        };

        this.props.getBoosterSetting( params, function(res) {
            if(res.errors && res.errors.length > 0) {
                toast(res.errors[0].message);
            }
            else {
                if(res.data) {
                    _this.boosterSetting = _.defaults(res.data, _this.boosterSetting);
                    console.log(_this.boosterSetting)
                    if(!_this.boosterSetting.temp) {
                        //
                    }
                }

            }
        });


        // this.props.getApplyShop( params, function(res) {
        //     if(res.errors && res.errors.length > 0) {
        //         toast(res.errors[0].message);
        //     }
        //     else {
        //         Storage.setObject('shops', res.data);
        //         _this.shops = res.data;
        //         console.log(_this.shops)
        //
        //     }
        // });

        // await this.props.getDoc('getResponseBotSettings', params, (res) => {
        //     if (res && res.data) {
        //         this.boosterSetting = res.data.settings || this.boosterSetting;
        //         this.channelType = res.data.channelType || this.channelType;
        //         this.messageLimit = res.data.messageLimit || this.messageLimit;
        //         this.messageLimitCount = res.data.messageLimitCount || this.messageLimitCount;
        //     }
        //     this.isLoading = false;
        // });

        // 설정 값 처리 후 아래 코드 삭제
        this.isLoading = false;
    };

    @action
    saveSettings = async () => {
        this.isLoading = true;
        // const params = {
        //     store_id: this.teamUser.selStore_id,
        //     shopNo: this.teamUser.selShopNo || 1,
        //     settings: this.boosterSetting,
        //     channelType: this.channelType,
        //     messageLimit: this.messageLimit,
        //     messageLimitCount: this.messageLimitCount
        // };
        //
        // await this.props.updateDoc('updateResponseBotSettings', params, (res) => {
        //     if (res.errors && res.errors.length > 0) {
        //         toast(res.errors[0].message);
        //     } else {
        //         toast("설정이 저장되었습니다.");
        //     }
        //     this.isLoading = false;
        // });
    };

    @action
    onToggleChange = (section) => {
        this.boosterSetting[section].enabled = !this.boosterSetting[section].enabled;
    };

    @action
    onRadioChange = (event, targetData, valType) => {
        const { name, value } = event.target;
        targetData[name] = valType === "int" ?  parseInt(value) : value;
    };

    @action
    onInputChange = (event) => {
        const { value, name } = event.target;
        if(name === "phonenumber") {
            this.teamUser.tel = value;
        }
        this.boosterSetting[name] = value;
    };

    @action
    onChangeChecked = async (event, targetObj, keyArray) => {
        if(keyArray[0]) {
            targetObj[keyArray[0]] = !targetObj[keyArray[0]];
        }
    };

    @action
    onChangeSelect = async (event) => {
        const { value, name } = event.target;
        if(name === "firstCate") {
            this.category[0] = value;
            let secondCate =  _.groupBy(categoryCode.data.secondBusinessType, "parentCode");
            this.categoryOptions.secondCate = secondCate[value];
        }
        else if(name === "secondCate") {
            this.category[1] = value;
            let thirdCate =  _.groupBy(categoryCode.data.thirdBusinessType, "parentCode");
            this.categoryOptions.thirdCate = thirdCate[value];
        }
        else if(name === "thirdCate") {
            this.category[2] = value;
            this.boosterSetting.categorycode = value;
        }
        else if(name === "sendStartTime" || name === "sendEndTime") {
            if(this.boosterSetting["sendStartTime"] >= this.boosterSetting["sendEndTime"]) {
                this.boosterSetting["sendEndTime"] = this.boosterSetting["sendStartTime"] + 1;
            }
            this.boosterSetting[name] = parseInt(value);
        }
    };

    @action
    onChangeStep = async (stepNo) => {
        let _this = this;
        if(!this.boosterSetting.kakaoPlusid || this.boosterSetting.kakaoPlusid === "") {
            alert("카카오 채널 검색용 아이디를 입력해 주세요.");
            return false;
        }
        if(stepNo > 2) {
            if(!this.boosterSetting.categorycode || this.boosterSetting.categorycode === "") {
                alert("카테고리를 선택해 주세요.");
                return false;
            }
            if(!this.boosterSetting.phonenumber || this.boosterSetting.phonenumber === "") {
                alert("전화번호를 입력해 주세요.");
                return false;
            }

        }
        if(stepNo > 4) {
            if(!this.boosterSetting.authnum || this.boosterSetting.authnum === "") {
                alert("인증번호를 입력해 주세요.");
                return false;
            }
        }

        if(stepNo === 2 || stepNo === 4) {
            stepNo = 4;
            this.authStep = stepNo;
        }
        if(stepNo === 3) {
            this.props.addKakaoProfile(this.boosterSetting, function(resp) {
                let res = resp.data;
                if(res) {
                    if(parseInt(res.code) < 0 || parseInt(res.code) > 100) {
                        //{code: -99, message: "이미등록된 플러스친구 ID입니다."}
                        alert(res.message);
                    }
                    else {
                        console.log("s", res);
                        _this.onChangeStep(4);
                    }
                }
                else {
                    console.log(res);
                }

            });
        }
        if(stepNo === 5) {
            this.props.addKakaoProfile(this.boosterSetting, function(resp) {
                let res = resp.data;
                if(res && res.code) {
                    if(res.code < 0) {
                        //{code: -99, message: "이미등록된 플러스친구 ID입니다."}
                        alert(res.message);
                    }
                    else {
                        _this.authStep = 1;
                        _this.boosterSetting = resp.data;
                    }
                }
                else {
                    _this.boosterSetting = resp.data;
                    toast("카카오 채널 연동이 완료되었습니다.");
                }


            });
        }

    };

    setBoosterSetting = async() => {
        let _this = this;
        // console.log('updateMassReview', updateData);
        let updateData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
            params: _.omit(this.boosterSetting, ['store_id', 'shopNo', 'kakaoPlusid']),
        }
        this.props.setBoosterSetting(updateData, function(res) {
            console.log(res);

        });
    }

    setKakaoTemp = async() => {
        let _this = this;
        // console.log('updateMassReview', updateData);
        _this.isLoading = true;
        let updateData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
            params: _.omit(this.boosterSetting, ['store_id', 'shopNo', 'kakaoPlusid']),
        }
        this.props.setKakaoTemp(updateData, function(res) {
            _this.isLoading = false;
            window.location.reload();


        });
    }

    adminCusData = async() => {
        let _this = this;

        let updateData = {
            store_id: this.store._id,
            shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        }
        // console.log('updateMassReview', updateData);
        this.props.adminCusData(updateData, function(res) {
            console.log(res);

        });
    }
    // todo
    //  1. 프로필 인증 -> 키(senderkey) 정보 데이터베이스 저장
    //  2. 템플릿 선택 및 템플릿 등록 및 검수 4-5일간의 검수
    //  3. 주문데이터 처리
    //  4. 발송 처리




    render() {
        let _this = this;
        return (
            <div className="main-content">
                <PageTitle />
                {/*<PageTitle title="답변봇 설정" />*/}
                {/*<p>일일 처리 및 반응을 인터넷 종합몰 설정에서 시간 영역은 가장 온라인이 높은 19시-20시 사이에 자동 반응되요!</p>*/}
                {/*<Row  className="mtb-10">*/}
                {/*    <Col xs={12}><Button onClick={event => this.adminCusData()}>커스텀</Button></Col>*/}
                {/*</Row>*/}
                {( this.isLogin && this.teamUser.emailId ) ? (
                    <div className="setting-box">
                        <Row>
                            <Col lg="8">
                                {!this.boosterSetting.isKakaoPlusidAuth ? (<>
                                    <Card className="mb-4">
                                        <CardHeader className="bg-light">
                                            <h5 className="m-0">카카오 채널설정</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="mr-3">관리자 연락처</span>
                                                <FormInput
                                                    placeholder="관리자 연락처"
                                                    name="tel"
                                                    value={this.teamUser.tel}
                                                    onChange={this.onInputChange}
                                                    className="mr-2"
                                                    style={{ maxWidth: '200px' }}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="mr-3">카카오 채널 검색용 아이디</span>
                                                <FormInput
                                                    placeholder="채널로그인"
                                                    name="kakaoPlusid"
                                                    value={this.boosterSetting.kakaoPlusid}
                                                    onChange={this.onInputChange}
                                                    className="mr-2"
                                                    style={{ maxWidth: '200px' }}
                                                />
                                                {!this.regedPlusId ? (
                                                    <Button theme="primary" onClick={event=> { this.onChangeStep(2)}}>등록하기</Button>
                                                ) : (
                                                    <Button theme="primary">변경하기</Button>
                                                )}

                                                {/*<Button theme="primary">변경하기</Button>*/}
                                            </div>
                                            {this.authStep > 1? (
                                                <div className="d-flex align-items-center mb-3  inline-selector">
                                                    <span className="mr-3">카테고리</span>
                                                    <FormSelect
                                                        value={this.category[0]}
                                                        name="firstCate"
                                                        onChange={event => {
                                                            this.onChangeSelect(event)
                                                        }}>
                                                        <option value="0">-선택해 주세요-</option>
                                                        {this.categoryOptions.firstCate.map((option) => (
                                                            <option key={option.code} value={option.code}>{option.name}</option>
                                                        ))}
                                                    </FormSelect>
                                                    {this.categoryOptions.secondCate && this.categoryOptions.secondCate.length > -1 ? (
                                                        <FormSelect
                                                            value={this.category[1]}
                                                            name="secondCate"
                                                            onChange={event => {
                                                                this.onChangeSelect(event)
                                                            }}>
                                                            <option value="0">-선택해 주세요-</option>
                                                            {this.categoryOptions.secondCate.map((option) => (
                                                                <option key={option.code} value={option.code}>{option.name}</option>
                                                            ))}
                                                        </FormSelect>
                                                    ) : null}
                                                    {this.categoryOptions.thirdCate && this.categoryOptions.thirdCate.length > -1 ? (
                                                        <FormSelect
                                                            value={this.category[2]}
                                                            name="thirdCate"
                                                            onChange={event => {
                                                                this.onChangeSelect(event)
                                                            }}>
                                                            <option value="0">-선택해 주세요-</option>
                                                            {this.categoryOptions.thirdCate.map((option) => (
                                                                <option key={option.code} value={option.code}>{option.name}</option>
                                                            ))}
                                                        </FormSelect>
                                                    ) : null}

                                                </div>
                                            ): null}
                                            {this.authStep > 1 && this.boosterSetting.categorycode ? (
                                                <div className="d-flex align-items-center mb-3">
                                                    <span className="mr-3">관리자 휴대폰번호</span>
                                                    <FormInput
                                                        name="phonenumber"
                                                        placeholder="01011111111"
                                                        value={this.boosterSetting.phonenumber}
                                                        onChange={this.onInputChange}
                                                        className="mr-2"
                                                        style={{ maxWidth: '200px' }}
                                                    />
                                                    <Button theme="primary" onClick={event=> { this.onChangeStep(3)}} >인증번호 받기</Button>
                                                    {this.authStep > 3 ? (
                                                        <>
                                                            <span className="ml-20 mr-3">인증번호</span>
                                                            <FormInput
                                                                name = "authnum"
                                                                placeholder="인증번호"
                                                                value={this.boosterSetting.authnum}
                                                                onChange={this.onInputChange}
                                                                className="mr-2"
                                                                style={{ maxWidth: '200px' }}
                                                            />
                                                            <Button theme="primary" onClick={event=> { this.onChangeStep(5)}}>등록하기</Button>
                                                        </>
                                                    ) : null}

                                                </div>
                                            ) : null}

                                            <h6>안내</h6>
                                            <p>카카오채널 정보의 검색용 아이디를 입력해 주세요.(<a href={"https://center-pf.kakao.com/_Tsxopxb/profile/settings"} target={"_blank"}>확인하기</a>)</p>
                                            <p>보유한 카카오채널 계정이 없을경우 ( <a href={"https://center-pf.kakao.com"} target={"_blank"}>https://center-pf.kakao.com</a> ) 에서 등록하신 후 진행 가능합니다.</p>
                                            <p>카카오채널 관리자로 등록된 휴대폰 번호를 입력 해주셔야 합니다.</p>
                                            <p>인증된 휴대폰 번호는 온똑똑 관리자의 전화번호와 함께 수정이 되며 인증된 번호는 수정이 불가능합니다.</p>
                                        </CardBody>
                                    </Card>
                                </>) : (<>
                                    <Card className="mb-4">
                                        <CardHeader className="bg-light">
                                            <h5 className="m-0">등록된 카카오 채널</h5>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="mr-3">카카오 채널 검색용 아이디</span>
                                                <FormInput
                                                    placeholder="채널로그인"
                                                    name="kakaoPlusid"
                                                    value={this.boosterSetting.kakaoPlusid}
                                                    readOnly
                                                    // onChange={this.onInputChange}
                                                    className="mr-2"
                                                    style={{ maxWidth: '200px' }}
                                                />
                                            </div>

                                        </CardBody>
                                    </Card>
                                </>)}
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="mr-10 float-l">후기작성 알림톡 설정</h5>
                                        {this.boosterSetting.isKakaoPlusidAuth ? (<>
                                        <span className="float-l">
                                            <FormCheckbox toggle small checked={this.boosterSetting.isSendMsg}
                                                          onChange={event => this.onChangeChecked(event, this.boosterSetting, ['isSendMsg'])}>
                                            </FormCheckbox>
                                        </span>
                                            <div className="float-r">
                                                <Button theme="primary" onClick={event=> { this.setBoosterSetting() }}>저장하기</Button>
                                            </div>
                                        </>) : (<p className="float-l">*카카오 채널을 등록해 주세요.</p>) }


                                    </CardHeader>
                                    <CardBody className={this.boosterSetting.isSendMsg ? "isUse" : "disabled"}>
                                        <p>상품 도착 후 첫회 발송 후 3일마다 발송</p>
                                        <div className="mt-4">
                                            <div className="d-flex align-items-center mb-2">
                                                <h6 className="mb-0 mr-3">상품 도착 후 첫 메시지 발송 시점</h6>
                                            </div>
                                            <div className="mtb-30 d-flex align-items-center">
                                                {this.firstSendOptions.map((option) => (
                                                    <FormRadio
                                                        key={option.value}
                                                        inline
                                                        className="mr-10"
                                                        name="firstSend"
                                                        value={option.value}
                                                        checked={this.boosterSetting.firstSend === option.value}
                                                        onChange={(event) => this.onRadioChange(event, this.boosterSetting, 'int')}
                                                    >
                                                        {option.label}
                                                    </FormRadio>
                                                ))}
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <h6 className="mb-0 mr-3">발송 시간대</h6>
                                            </div>
                                            <div className="mtb-30 d-flex align-items-center">
                                                <div className="time-range d-flex align-items-center">
                                                    <FormSelect
                                                        value={this.boosterSetting.sendStartTime}
                                                        name="sendStartTime"
                                                        onChange={event => {
                                                            this.onChangeSelect(event)
                                                        }}
                                                        style={{width: '100px'}}
                                                    >
                                                        {Array.from({length: 17}, (_, i) => i + 6).map((hour) => (
                                                            <option key={hour} value={hour}>
                                                                {hour.toString().padStart(2, '0')}:00
                                                            </option>
                                                        ))}
                                                    </FormSelect>
                                                  <span className="mx-2">~</span>
                                                  <FormSelect
                                                    value={this.boosterSetting.sendEndTime}
                                                    name="sendEndTime"
                                                    onChange={event => {
                                                      this.onChangeSelect(event)
                                                    }}
                                                    style={{width: '100px'}}
                                                  >
                                                      {Array.from({length: 15-_this.boosterSetting.sendStartTime + 8}, (_, i) => i + _this.boosterSetting.sendStartTime + 1).map((hour) => (
                                                          <option key={hour} value={hour}>
                                                              {hour.toString().padStart(2, '0')}:00
                                                          </option>
                                                      ))}
                                                  </FormSelect>
                                                </div>
                                            </div>

                                            {/*<div className="mtb-10 d-flex align-items-center mb-2">*/}
                                            {/*    <h6 className="mb-0 mr-3">미작성 재발송 사용</h6>*/}
                                            {/*</div>*/}
                                            {/*<div className="mtb-30 d-flex align-items-center">*/}
                                            {/*    <FormCheckbox toggle small checked={this.boosterSetting.isResend}*/}
                                            {/*                  onChange={event => this.onChangeChecked(event, this.boosterSetting, ['isResend'])}>*/}
                                            {/*        {this.boosterSetting.isResend ? '재발송하기' : '사용안함'}*/}
                                            {/*    </FormCheckbox>*/}
                                            {/*</div>*/}
                                            {/*<div className="mtb-10 d-flex align-items-center mb-2">*/}
                                            {/*    <h6 className="mb-0 mr-3">메시지 발송 방식 선택 (개별/통합)</h6>*/}
                                            {/*</div>*/}
                                            {/*<div className="mtb-30 d-flex align-items-center">*/}
                                            {/*    {this.resendTypeOptions.map((option) => (*/}
                                            {/*        <FormRadio*/}
                                            {/*            key={option.value}*/}
                                            {/*            inline*/}
                                            {/*            className="mr-10"*/}
                                            {/*            name="resendType"*/}
                                            {/*            value={option.value}*/}
                                            {/*            checked={this.boosterSetting.resendType === option.value}*/}
                                            {/*            onChange={(event) => this.onRadioChange(event, this.boosterSetting, 'string')}*/}
                                            {/*        >*/}
                                            {/*            {option.label}*/}
                                            {/*        </FormRadio>*/}
                                            {/*    ))}*/}
                                            {/*</div>*/}
                                            <div className="mtb-10 d-flex align-items-center mb-2">
                                                <h6 className="mb-0 mr-3">미작성 재발송 주기</h6>
                                            </div>
                                            <div className="mtb-30 d-flex align-items-center">
                                                {this.sendIntervalOptions.map((option) => (
                                                    <FormRadio
                                                        key={option.value}
                                                        inline
                                                        className="mr-10"
                                                        name="sendInterval"
                                                        value={option.value}
                                                        checked={this.boosterSetting.sendInterval === option.value}
                                                        onChange={(event) => this.onRadioChange(event, this.boosterSetting, 'int')}
                                                    >
                                                        {option.label}
                                                    </FormRadio>
                                                ))}
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <h6 className="mb-0 mr-3">미작성 재발송 횟수</h6>
                                            </div>
                                            <div className="mtb-30 d-flex align-items-center">
                                                {this.sendCountOptions.map((option) => (
                                                    <FormRadio
                                                        key={option.value}
                                                        inline
                                                        className="mr-10"
                                                        name="sendCount"
                                                        value={option.value}
                                                        checked={this.boosterSetting.sendCount === option.value}
                                                        onChange={(event) => this.onRadioChange(event, this.boosterSetting, 'int')}
                                                    >
                                                        {option.label}
                                                    </FormRadio>
                                                ))}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>

                                {/*<Card className="mb-4">*/}
                                {/*    <CardBody>*/}
                                {/*        <div className="d-flex justify-content-between align-items-center mb-3">*/}
                                {/*            <h5 className="m-0">장바구니 리뷰 요청</h5>*/}
                                {/*            <div className="toggle-switch">*/}
                                {/*                <input*/}
                                {/*                    type="checkbox"*/}
                                {/*                    id="review-request-toggle"*/}
                                {/*                    checked={this.boosterSetting.reviewRequest.enabled}*/}
                                {/*                    onChange={() => this.onToggleChange('reviewRequest')}*/}
                                {/*                />*/}
                                {/*                <label htmlFor="review-request-toggle"></label>*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*        <p className="text-muted">구매 고객에게 리뷰 작성 요청을 발송하고 리뷰 작성률을 700% 높일 수 있습니다.</p>*/}

                                {/*        <div className="mt-3">*/}
                                {/*            <div className="mb-2">발송 시점</div>*/}
                                {/*            <FormGroup>*/}
                                {/*                <FormRadio*/}
                                {/*                    name="replyType"*/}
                                {/*                    value='"Cafe24의 배송대기 상태(승인완료 후)" 변경 후 답변'*/}
                                {/*                    checked={this.boosterSetting.reviewRequest.replyType === '"Cafe24의 배송대기 상태(승인완료 후)" 변경 후 답변'}*/}
                                {/*                    onChange={(e) => this.onRadioChange(e, 'reviewRequest')}*/}
                                {/*                >*/}
                                {/*                    "Cafe24의 배송대기 상태(승인완료 후)" 변경 후 답변*/}
                                {/*                </FormRadio>*/}
                                {/*            </FormGroup>*/}

                                {/*            <FormGroup>*/}
                                {/*                <div className="d-flex align-items-center">*/}
                                {/*                    <FormRadio*/}
                                {/*                        name="replyType"*/}
                                {/*                        value='"Cafe24의 배송중" 상태로도 변경 후 답변'*/}
                                {/*                        checked={this.boosterSetting.reviewRequest.replyType === '"Cafe24의 배송중" 상태로도 변경 후 답변'}*/}
                                {/*                        onChange={(e) => this.onRadioChange(e, 'reviewRequest')}*/}
                                {/*                    >*/}
                                {/*                        "Cafe24의 배송중" 상태로도*/}
                                {/*                    </FormRadio>*/}
                                {/*                    <FormInput*/}
                                {/*                        type="number"*/}
                                {/*                        value={this.boosterSetting.reviewRequest.deliveryDays}*/}
                                {/*                        onChange={(e) => this.onInputChange(e, 'reviewRequest', 'deliveryDays')}*/}
                                {/*                        className="mx-2"*/}
                                {/*                        style={{ width: '60px' }}*/}
                                {/*                    />*/}
                                {/*                    <span>일 후 또는 배송완료 상태 변경 후 답변</span>*/}
                                {/*                </div>*/}
                                {/*            </FormGroup>*/}

                                {/*            <FormGroup>*/}
                                {/*                <FormRadio*/}
                                {/*                    name="replyType"*/}
                                {/*                    value='"Cafe24의 배송완료 상태"로 변경 후 답변'*/}
                                {/*                    checked={this.boosterSetting.reviewRequest.replyType === '"Cafe24의 배송완료 상태"로 변경 후 답변'}*/}
                                {/*                    onChange={(e) => this.onRadioChange(e, 'reviewRequest')}*/}
                                {/*                >*/}
                                {/*                    "Cafe24의 배송완료 상태"로 변경 후 답변*/}
                                {/*                </FormRadio>*/}
                                {/*            </FormGroup>*/}
                                {/*        </div>*/}
                                {/*    </CardBody>*/}
                                {/*</Card>*/}

                                {/*<Card className="mb-4">*/}
                                {/*    <CardBody>*/}
                                {/*        <div className="d-flex justify-content-between align-items-center mb-3">*/}
                                {/*            <h5 className="m-0">회원가입 응답 알림톡</h5>*/}
                                {/*            <div className="toggle-switch">*/}
                                {/*                <input*/}
                                {/*                    type="checkbox"*/}
                                {/*                    id="signup-response-toggle"*/}
                                {/*                    checked={this.boosterSetting.signupResponse.enabled}*/}
                                {/*                    onChange={() => this.onToggleChange('signupResponse')}*/}
                                {/*                />*/}
                                {/*                <label htmlFor="signup-response-toggle"></label>*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*        <p className="text-muted">신규 회원 중 회원을 수익이 가능한 회원판 고객의 회원가입을 유도합니다.</p>*/}
                                {/*    </CardBody>*/}
                                {/*</Card>*/}

                                {/*<Card className="mb-4">*/}
                                {/*    <CardBody>*/}
                                {/*        <div className="d-flex justify-content-between align-items-center mb-3">*/}
                                {/*            <h5 className="m-0">일반리뷰 리마인더</h5>*/}
                                {/*            <div className="toggle-switch">*/}
                                {/*                <input*/}
                                {/*                    type="checkbox"*/}
                                {/*                    id="general-reminder-toggle"*/}
                                {/*                    checked={this.boosterSetting.generalReviewReminder.enabled}*/}
                                {/*                    onChange={() => this.onToggleChange('generalReviewReminder')}*/}
                                {/*                />*/}
                                {/*                <label htmlFor="general-reminder-toggle"></label>*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*        <p className="text-muted">장시간 상점 방문 중 회원을 적십위자 잠은 고객을 리구매에 일으킵니다.</p>*/}

                                {/*        <div className="mt-3">*/}
                                {/*            <div className="mb-2">발송 시점</div>*/}
                                {/*            <div className="d-flex align-items-center">*/}
                                {/*                <span className="mr-2">지난번 구매 방문 후</span>*/}
                                {/*                <FormInput*/}
                                {/*                    type="number"*/}
                                {/*                    value={this.boosterSetting.generalReviewReminder.inactiveDays}*/}
                                {/*                    onChange={(e) => this.onInputChange(e, 'generalReviewReminder', 'inactiveDays')}*/}
                                {/*                    className="mr-2"*/}
                                {/*                    style={{ width: '60px' }}*/}
                                {/*                />*/}
                                {/*                <span>일 후 아직 리뷰를 적십위자 잠은 고객에게 발송</span>*/}
                                {/*            </div>*/}
                                {/*            <p className="text-muted mt-2">*/}
                                {/*                매번 지금 및 리뷰 작성이 동기화 조건에서 일반토이 발송되지 않습니다.*/}
                                {/*                <Button theme="link" className="p-0 ml-2">자세히 보기</Button>*/}
                                {/*            </p>*/}
                                {/*        </div>*/}
                                {/*    </CardBody>*/}
                                {/*</Card>*/}

                                {/*<Card className="mb-4">*/}
                                {/*    <CardHeader className="bg-light d-flex justify-content-between align-items-center">*/}
                                {/*        <h5 className="m-0">포토/동영상 리마인더</h5>*/}
                                {/*        <Badge theme="warning" className="ml-2">유료</Badge>*/}
                                {/*    </CardHeader>*/}
                                {/*    <CardBody>*/}
                                {/*        <p className="text-muted">포토리뷰, 동영상리뷰와 같은 미디어를 게출하지 않은 경우 발송하는 리마인더에요!</p>*/}
                                {/*    </CardBody>*/}
                                {/*</Card>*/}

                                {/*<Card className="mb-4">*/}
                                {/*    <CardHeader className="bg-light d-flex justify-content-between align-items-center">*/}
                                {/*        <h5 className="m-0">장기 사용 리뷰 리마인더</h5>*/}
                                {/*        <Badge theme="warning" className="ml-2">유료</Badge>*/}
                                {/*    </CardHeader>*/}
                                {/*    <CardBody>*/}
                                {/*        <p className="text-muted">일정 기간 제품 사용 후 두 번째뷰 작성을 유도하는 기능이에요!</p>*/}
                                {/*    </CardBody>*/}
                                {/*</Card>*/}

                                {/*<Card className="mb-4">*/}
                                {/*    <CardHeader className="bg-light d-flex justify-content-between align-items-center">*/}
                                {/*        <h5 className="m-0">인터뷰 요청</h5>*/}
                                {/*        <Badge theme="warning" className="ml-2">유료</Badge>*/}
                                {/*    </CardHeader>*/}
                                {/*    <CardBody>*/}
                                {/*        <p className="text-muted">특정 고객에게 스타일에 대한 상세한 리뷰를 남길 수 있도록 질문이를 발송하는 기능이에요!</p>*/}
                                {/*    </CardBody>*/}
                                {/*</Card>*/}

                                {/*<div className="text-center mt-4">*/}
                                {/*    <Button size="lg" theme="primary" onClick={this.saveSettings}>저장하기</Button>*/}
                                {/*    <Button size="lg" theme="secondary" className="ml-2">취소</Button>*/}
                                {/*</div>*/}
                            </Col>

                            <Col lg="4">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">미리보기</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {this.boosterSetting && this.boosterSetting.temp ? (
                                            <>
                                                {(() => {
                                                    switch (this.boosterSetting.temp.inspStatus) {
                                                        case "REG":
                                                        case "REQ":
                                                            return <p className="mb-3 font-weight-bold text-red">템플릿 등록 시 검수기간은 영업일 기준
                                                                3~5일 소요됩니다.</p>;
                                                        break;
                                                        case "REJ":
                                                            return <p className="text-red mb-3">템플릿 등록이 실패하였습니다.</p>;
                                                        case "APR":
                                                            return <p className="text-muted mb-3">템플릿 등록이 완료되었습니다.</p>;
                                                        break;
                                                        default:
                                                            return <p className="text-muted mb-3"></p>;
                                                    }
                                                })()}
                                                <div className="text-center mtb-20"><img src={imgKakaoTemp} /></div>
                                            </>
                                        ) : this.boosterSetting.isKakaoPlusidAuth ? (<div className="text-center"><Button onClick={event => this.setKakaoTemp()}>템플릿 등록</Button></div>) : (<p className={"text-center"}>카카오 채널을 등록해 주세요</p>) }

                                        {/*<div className="text-center"><Button onClick={event => window.location.reload()}>새로고침</Button></div>*/}


                                        {/*<div className="kakao-preview">*/}
                                        {/*    <div className="kakao-header d-flex align-items-center justify-content-between p-2">*/}
                                        {/*        <div className="d-flex align-items-center">*/}
                                        {/*            <span className="font-weight-bold">알림톡 도착</span>*/}
                                        {/*        </div>*/}
                                        {/*        <div className="kakao-logo"><span className="badge badge-light rounded-circle"><img src="/api/placeholder/30/30" alt="Kakao" className="rounded-circle" /></span></div>*/}
                                        {/*    </div>*/}

                                        {/*    <div className="p-3">*/}
                                        {/*        <div className="text-center mb-3">*/}
                                        {/*            <h6 className="font-weight-bold">추기를 기다리는<br />상품이 도착했어요.</h6>*/}
                                        {/*            <div className="mt-2">*/}
                                        {/*                <img src="/api/placeholder/70/70" alt="Review icon" className="rounded" />*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}

                                        {/*        <div className="message-content mt-3">*/}
                                        {/*            <p>안녕하세요, 홍길동님!</p>*/}
                                        {/*            <p>엄마리부티에서 구매하신 작업물 상품 배송지 잘 3개 상품은 어떠신가요?</p>*/}
                                        {/*            <p>맘은 부족해 도움이 될 수 있도록 아래 버튼을 눌러 홍길동님의 소중한 후기를 공유해주세요.</p>*/}
                                        {/*            <p><span role="img" aria-label="thumbs up">👍</span> 아직 상품 수령 전이신가요?<br />배송 조회 버튼을 통해 확인해보세요.<br />운송장번호 483924839</p>*/}
                                        {/*        </div>*/}
                                        {/*        */}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                    ) :
                    null
                }




                <ModalLoading isLoading={this.isLoading} />
            </div>
        );
    }
}

export default KakaoMsgSetting;